
<template >
  <d2-container>
    <template slot="header">

    </template>
    <div class="inner">
      <el-table :data="tableDataList"
                style="width: 100%">
        <el-table-column type="index"
                         width="50">
        </el-table-column>
        <el-table-column label="产品名称"
                         width="180">
          <template slot-scope="scope">
            <!-- <span style="margin-left: 10px">{{ scope.row.thombTypeName }}</span> -->
            <span>{{ scope.row.subCampProduct.productName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="单价"
                         width="80">
          <template slot-scope="scope">
            <!-- <span style="margin-left: 10px">{{ scope.row.description }}</span> -->
            <span>{{ scope.row.price }}</span>
          </template>
        </el-table-column>
        <el-table-column label="数量"
                         width="80">
          <template slot-scope="scope">
            <!-- <span style="margin-left: 10px">{{ scope.row.description }}</span> -->
            <span>{{ scope.row.amount }}</span>

          </template>
        </el-table-column>
      </el-table>
    </div>
  </d2-container>
</template>
<script>
import { mapActions } from 'vuex'
import util from '@/libs/util'
export default {
  title: '自定义列模板',
  index: 14,
  data () {

    return {
      subCampProductBizRecId: this.$route.query.subCampProductBizRecId,
      tableDataList: [],
      loading: '',
    }
  },
  methods: {
    ...mapActions('d2admin/subCampProduct', [
      'subCampProductDetail',
    ]),
    subCampProductDetailOfWechat () {
      this.loading = this.$loading({
        fullscreen: true,
        text: '加载中',
        background: "rgba(0, 0, 0, 0.6)"
      })
      this.subCampProductDetail({
        vm: this,
        subCampProductBizRecId: this.subCampProductBizRecId
      })
    }
  },
  mounted () {
    this.subCampProductDetailOfWechat()
  }
}
</script>
